import React from "react";
import ShareIcon from "@mui/icons-material/Share";
import { ButtonV2 } from "@Modules/common/ButtonV2";
import moduleStyle from "./Style.module.scss";

const ShareOffering = ({
    onShareEventCtaClick,
    shareEventCtaText,
}: {
    onShareEventCtaClick: () => void;
    shareEventCtaText: string;
}) => {
    return (
        <ButtonV2
            onClick={onShareEventCtaClick}
            className={`${moduleStyle.button} w-100 d-flex align-items-center justify-content-center `}
        >
            {shareEventCtaText} <ShareIcon className="ml-1" />
        </ButtonV2>
    );
};

export default ShareOffering;
